'use strict';

import Collection from './collection.js';
import CompanyLocation from 'newModels/company-location.js';

export default class CompanyLocations extends Collection {
    url() {
        if (this.company) {
            return this.company.url() + '/locations';
        }
        return '/CompanyLocations';
    }

    initialize(models, {company = null}) {
        this.model = CompanyLocation;
        super.initialize(...arguments);
        this.company = company;
        return this;
    }

    /**
     * Get the primary location in the collection, if it exists
     *
     * @instance
     * @returns {module:models.CompanyLocation}
     */
    getPrimary() {
        return this.find(model => (model.get('primary') === true));
    }

    dirty() {
        return this.reduce((memo, model) => {
            return memo || (
                (model.dirty() && !model.isNew()) || model.isNew()
            );
        }, false) || (this.removedModels.length > 0);
    }

    fetchAddresses() {
        return Promise.all(this.map(model => model.fetchAddress()))
            .then(() => this);
    }

    fetchEmployees() {
        return Promise.all(this.map(model => model.fetchEmployees()))
            .then(() => this);
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/company-locations.js